import { Col } from 'antd'
import type React from 'react'
import { forwardRef } from 'react'

type Props = {
  children: React.ReactElement
  id?: string
}

const Card = forwardRef<HTMLDivElement, Props>(
  ({ children, id }: Props, ref) => (
    <Col xs={24} sm={24} md={12} lg={8} xl={8} id={id} ref={ref}>
      {children}
    </Col>
  )
)

export default Card
